import { applyLandingBrand } from "@/lib/siteHosts"

export const originContent = applyLandingBrand({
  title: "An Infrastructure Built by Roofers, for Roofers",
  lead:
    "We didn't build this in Silicon Valley. We built it on job sites to stop our own business from bleeding revenue.",
  points: [
    {
      label: "The Origin:",
      summary: "Born from real job-site friction",
      figure: "Born from real job-site friction",
      body:
        "We co-own roofing operations. We built this architecture for ourselves because we were tired of paying Google and Facebook for leads, only to lose them to faster competitors while on site.",
    },
    {
      label: "The Solution:",
      summary: "26-second speed-to-lead interception",
      figure: "26-second speed-to-lead interception",
      body: {
        intro:
          "The FractoLabs Roofing Digital Assistant acts as your 24/7 instant-response employee.",
        lead: "In under 26 seconds, it automatically:",
        items: [
          "Intercepts every inbound lead the second it arrives.",
          "Qualifies project scope and damage details.",
          "Books estimate inspections directly to your calendar.",
        ],
        close: "All before a competitor even sees the notification.",
      },
    },
    {
      label: "The Setup:",
      summary: "12-minute plug-and-play setup",
      figure: "12-minute plug-and-play setup",
      body: "Integrates with your current site in 12 minutes. Zero technical routine for your team.",
    },
  ],
})
